import React from 'react';
import CommonQuestions from '../../components/commonQuestions'

const NewDsmLicense = () => {
  return (
    <div>
        <CommonQuestions  OrderType={'New BU/Separate License/new DSM license'}/>
    </div>
  );
};


export default NewDsmLicense;
